export default __webpack_public_path__ + "static/media/header-bottom-art.fe3296b5.png";